import { Node as FlowNode, Edge as FlowEdge, Position, MarkerType } from 'reactflow';
import { NodeExecutionCondition, NodeTestRunInstance, WorkflowNode } from '../../types/workflow';
import { WorkflowIntegration } from '../../types/integrations';
import { NodeConfig } from '../../types/nodes';

const createFlowNode = (
    id: string,
    service: string,
    index: number,
    nodeConfigs: any,
    integrations: WorkflowIntegration[] | undefined,
    onNodeClick: (workflowNode: WorkflowNode) => void,
    isLeafNode: (node: WorkflowNode) => boolean,
    workflowNode: WorkflowNode,
    updateNodeConfigsFromRunInstances: (nodeId: string, response_config: string, nodeConfigs?: Record<string, NodeConfig>) => void,
    setTestRunInstances: React.Dispatch<React.SetStateAction<Record<string, NodeTestRunInstance>>>,
    handleAddNodeClick: () => void,
    deleteNodeById: (params: { nodeId: string }) => void,
    shouldDeleteNode: () => void,
    setNodeConfigs: React.Dispatch<React.SetStateAction<Record<string, NodeConfig>>>,
    setNodeResponseConfigs: React.Dispatch<React.SetStateAction<Record<string, Record<string, string>>>>,
    setNodeConfigsForNodeInRef: (nodeId: string, newNodeConfigs: NodeConfig) => void,
    refreshWorkflowNodes: () => void,
    executionConditionsForNode: NodeExecutionCondition[],
    getHasChildren: (node: WorkflowNode) => boolean,
): FlowNode => {
    const nodeData: WorkflowNode = workflowNode || {
        node: {
            id,
            service,
        }
    };

    return {
        id: id,
        type: 'workflowNode',
        data: {
            workflowType: service,
            workflowBoxIndex: index + 1,
            workflowTitle: nodeData.node.name || '',
            nodeConfigs: nodeConfigs,
            nodeId: id,
            integrations: integrations,
            onNodeClick: onNodeClick,
            workflowNode: nodeData,
            isLeaf: isLeafNode(nodeData),
            onMenuClick: (e: React.MouseEvent) => {
                e.stopPropagation();
                // Handle menu click
            },
            updateNodeConfigsFromRunInstances,
            setTestRunInstances,
            handleAddNodeClick,
            deleteNodeById,
            shouldDeleteNode,
            setNodeConfigs,
            setNodeResponseConfigs,
            setNodeConfigsForNodeInRef,
            refreshWorkflowNodes,
            executionConditionsForNode,
            getHasChildren,
        },
        position: { x: 0, y: 0 },
        targetPosition: Position.Top,
        sourcePosition: Position.Bottom,
        draggable: false,
    };
};

export const convertToFlowNodes = (
    workflowNodes: WorkflowNode[], 
    nodeConfigs: any, 
    integrations: WorkflowIntegration[] | undefined, 
    onNodeClick: (workflowNode: WorkflowNode) => void,
    isLeafNode: (node: WorkflowNode) => boolean,
    updateNodeConfigsFromRunInstances: (nodeId: string, response_config: string, nodeConfigs?: Record<string, NodeConfig>) => void,
    setTestRunInstances: React.Dispatch<React.SetStateAction<Record<string, NodeTestRunInstance>>>,
    handleAddNodeClick: () => void,
    deleteNodeById: (params: { nodeId: string }) => void,
    shouldDeleteNode: () => void,
    setNodeConfigs: React.Dispatch<React.SetStateAction<Record<string, NodeConfig>>>,
    setNodeResponseConfigs: React.Dispatch<React.SetStateAction<Record<string, Record<string, string>>>>,
    setNodeConfigsForNodeInRef: (nodeId: string, newNodeConfigs: NodeConfig) => void,
    refreshWorkflowNodes: () => void,
    executionConditionsForNodes: Record<string, NodeExecutionCondition[]>,
    getHasChildren: (node: WorkflowNode) => boolean,
): FlowNode[] => {
    return workflowNodes.map((workflowNode, index) => 
        createFlowNode(
            workflowNode.node.id || `temp-${index}`,
            workflowNode.node.service || '',
            index,
            nodeConfigs,
            integrations,
            onNodeClick,
            isLeafNode,
            workflowNode,
            updateNodeConfigsFromRunInstances,
            setTestRunInstances,
            handleAddNodeClick,
            deleteNodeById,
            shouldDeleteNode,
            setNodeConfigs,
            setNodeResponseConfigs,
            setNodeConfigsForNodeInRef,
            refreshWorkflowNodes,
            workflowNode?.node?.id && executionConditionsForNodes[workflowNode.node.id] ? executionConditionsForNodes[workflowNode.node.id] : [],
            getHasChildren
        )
    );
};
